import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { externalUsersApiRef } from './api/ExternalUsersApi';
import { ExternalUsersClient } from './api/ExternalUsersClient';

export const externalOnboardingPlugin = createPlugin({
  id: 'external-onboarding',
  apis: [
      createApiFactory({
        api: externalUsersApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new ExternalUsersClient(discoveryApi, fetchApi),
      }),
    ],
  routes: {
    root: rootRouteRef,
  },
});

export const ExternalOnboardingPage = externalOnboardingPlugin.provide(
  createRoutableExtension({
    name: 'ExternalOnboardingPage',
    component: () =>
      import('./components/ExternalUsersPage/ExternalUsersPage').then(m => m.ExternalUsersPage),
    mountPoint: rootRouteRef,
  }),
);
